import { useEffect } from 'react';
import dayjs from 'dayjs';
import { UserLanguage } from 'lib/context';

export const useDayjsLanguage = (userLanguage: UserLanguage) => {
  useEffect(() => {
    const locale = userLanguage || 'en';
    dayjs.locale(locale);
  }, [userLanguage]);
};
